const UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE = 'UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE';
const UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE_READ = 'UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE_READ';
export const initialState = {};
/**
 * APIの戻り値を設定
 * @param viewRequestId 閲覧申請ID
 * @param data APIの戻り値
 */
export const updateRfpCliFileMessageAction = (viewRequestId, data) => ({
    payload: {
        data,
        viewRequestId,
    },
    type: UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE,
});
/**
 * 指定の閲覧申請に一致するメッセージ全てを既読状態にする
 * @param viewRequestId 閲覧申請ID
 */
export const setRfpCliFileMessageReadAction = (viewRequestId) => ({
    payload: {
        viewRequestId,
    },
    type: UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE_READ,
});
/**
 * reducer処理
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
    var _a;
    switch (action.type) {
        case UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE:
            // API実行の戻り値を設定
            return Object.assign(Object.assign({}, state), { [action.payload.viewRequestId]: action.payload.data });
        case UPDATE_RFP_CLIENT_ONE_FILE_ONE_MESSAGE_READ:
            return Object.assign(Object.assign({}, state), { [action.payload.viewRequestId]: Object.assign(Object.assign({}, state[action.payload.viewRequestId]), { 
                    // 全て既読済みに設定
                    messages: (_a = state[action.payload.viewRequestId]) === null || _a === void 0 ? void 0 : _a.messages.map((message) => (Object.assign(Object.assign({}, message), { is_unread: false }))), unread_count: 0 }) });
        default:
            return state;
    }
};
